const apikey = "AIzaSyDYNv73w5Z09u1ZxzF_NfOSB2pkYaw2z7c"

export { apikey }